export default {

  "skeleton": {

    "Date": "2020-02-18T18:53:51.820Z",

    "Description": "O projecto de 2020-02-18",

    "input": {

      "type": 1,

      "location": 1,
      "country": "Portugal",

      "lang": "pt",

      "direction": 1,
      "format": 2,

      "inclination": 5,

      "modelSpans": [0.2, 3, 0.2],
      "hasCantilever": true,
      "transversalDistance": 2.5,
      "supportWidth": 2,

      "loads": [

        {
          "case": "permanent",
          "type": "distributed_min",
          "value": [0, 0, 0],
          "dt": [1, "n"]
        },
        {
          "case": "permanent",
          "type": "distributed_max",
          "value": [0, 0, 0],
          "dt": [1, "n"]
        },
        {
          "case": "permanent",
          "type": "point",
          "value": [],
          "dt": ["d", "p"]
        },

        {
          "case": "live",
          "type": "distributed",
          "value": [0, 0, 0],
          "dt": [1, "n"]
        },
        {
          "case": "live",
          "type": "point",
          "value": [],
          "dt": ["d", "p"]
        },

        {
          "case": "wind",
          "type": "pressure",
          "value": [
            [0, 0],
            [0, 0],
            [0, 0]
          ],
          "dt": [3, 2]
        },
        {
          "case": "wind",
          "type": "suction",
          "value": [
            [0, 0],
            [0, 0],
            [0, 0]
          ],
          "dt": [3, 2]
        },
        {
          "case": "windLocal",
          "type": "pressure",
          "value": [
            [0, 0],
            [0, 0],
            [0, 0]
          ],
          "dt": [3, 2]
        },
        {
          "case": "windLocal",
          "type": "suction",
          "value": [
            [0, 0],
            [0, 0],
            [0, 0]
          ],
          "dt": [3, 2]
        },

        {
          "case": "snow",
          "type": "regular",
          "value": [0, 0, 0],
          "dt": [1, "n"]
        },

        {
          "case": "snow",
          "type": "exceptional",
          "value": [0, 0, 0],
          "dt": [1, "n"]
        },

        {
          "case": "snow",
          "type": "accumulation",
          "value": [
            [0, 0],
            [0, 0],
            [0, 0]
          ],
          "dt": [3, 2]
        },

        {
          "case": "axial",
          "type": "axialRegular",
          "value": 0,
          "dt": [1, 1]
        }
      ],

      "deformation": {
        "limit": 200,
        "combination": 1
      },

      "spanRestraints": {
        "upperFibre": [-1],
        "lowerFibre": [0]
      },

      "combinationFactors": {
        "live": { "id": 1, "value": [0.0, 0.0, 0.0] },
        "wind": { "id": 1, "value": [0.6, 0.2, 0.0] },
        "snow": { "id": 1, "value": [0.5, 0.2, 0.0] }
      },

      "internal": {

        "loads": {

          "distributed": {
            "permanent": {
              "isMinMaxModeOn": false
            }
          },

          "points": {

            "permanent": [
              {
                "value": [0, 0, 0, 0],
                "span": [1, 2, 3]
              }
            ],

            "live": [
              {
                "value": [0, 0, 0, 0],
                "span": [1, 2, 3]
              }
            ]
          },

          "axial": {
            "value": 0,
            "direction": 1
          },

          "windLocal": false,

          "snowAccumulation": false,

          "snowExceptional": false,

          "isWindLoadsByBand": false

        },

        "axial": false,

        "spanRestraints": true
      }
    }
  },

  "constants": {

    "version": "1.0.4",

    "phis-defaults": {
      "live": {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1
      },
      "snow": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1
      },
      "wind": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1
      }
    },

    "phis": {

      "live": {

        "type-1": {

          "list": {
            "-1": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "H category: roof", "value": [0, 0, 0] }
            ],
            "1": [
              { "id": 0, "text": "Definido pelo utilizador", "value": [0, 0, 0] },
              { "id": 1, "text": "Categoria H: coberturas", "value": [0, 0, 0] }
            ],
            "2": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "H category: roof", "value": [0, 0, 0] }
            ],
            "3": [
              { "id": 0, "text": "Definido por el usuario", "value": [0, 0, 0] },
              { "id": 1, "text": "Categoría H: coberturas", "value": [0, 0, 0] }
            ],
            "4": [
              { "id": 0, "text": "Défini par l'utilisateur", "value": [0, 0, 0] },
              { "id": 1, "text": "Catégorie H: couverture", "value": [0, 0, 0] }
            ],
            "5": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "H category: roof", "value": [0, 0, 0] }
            ]
          }
        },

        "type-2": {

          "list": {
            "-1": [{ "id": 0, "text": "User defined", "value": [0, 0, 0] }],
            "1": [{ "id": 0, "text": "Definido pelo utilizador", "value": [0, 0, 0] }],
            "2": [{ "id": 0, "text": "User defined", "value": [0, 0, 0] }],
            "3": [{ "id": 0, "text": "Definido por el usuario", "value": [0, 0, 0] }],
            "4": [{ "id": 0, "text": "Défini par l'utilisateur", "value": [0, 0, 0] }],
            "5": [{ "id": 0, "text": "Benutzerdefiniert", "value": [0, 0, 0] }]
          }
        },

        "type-3": {

          "list": {
            "-1": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "A category: Residential Areas", "value": [0.7, 0.5, 0.3] },
              { "id": 2, "text": "B category: Office Zones", "value": [0.7, 0.5, 0.3] },
              { "id": 3, "text": "C category: Meeting Zones", "value": [0.7, 0.7, 0.6] },
              { "id": 4, "text": "D category: Commercial Areas", "value": [0.7, 0.7, 0.6] },
              { "id": 5, "text": "E category: Storage Zones", "value": [1.0, 0.9, 0.8] },
              { "id": 6, "text": "F category: Light Vehicle Circulation Areas (<=30 kN)", "value": [0.7, 0.7, 0.6] },
              { "id": 7, "text": "G category: Medium Vehicle Circulation Zones (>30 kN and <=160 kN)", "value": [0.7, 0.5, 0.3] }
            ],
            "1": [
              { "id": 0, "text": "Definido pelo utilizador", "value": [0, 0, 0] },
              { "id": 1, "text": "Categorias A: Zonas Residenciais", "value": [0.7, 0.5, 0.3] },
              { "id": 2, "text": "Categorias B: Zonas de Escritórios", "value": [0.7, 0.5, 0.3] },
              { "id": 3, "text": "Categorias C: Zonas de Reunião", "value": [0.7, 0.7, 0.6] },
              { "id": 4, "text": "Categorias D: Zonas Comerciais", "value": [0.7, 0.7, 0.6] },
              { "id": 5, "text": "Categorias E: Zonas de Armazenamento", "value": [1.0, 0.9, 0.8] },
              { "id": 6, "text": "Categorias F: Zonas de Circulação Veículos Ligeiros (<=30 kN)", "value": [0.7, 0.7, 0.6] },
              { "id": 7, "text": "Categorias G: Zonas de Circulação Veículos Médios (>30 kN e <=160 kN)", "value": [0.7, 0.5, 0.3] }
            ],
            "2": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "A category: Residential Areas", "value": [0.7, 0.5, 0.3] },
              { "id": 2, "text": "B category: Office Zones", "value": [0.7, 0.5, 0.3] },
              { "id": 3, "text": "C category: Meeting Zones", "value": [0.7, 0.7, 0.6] },
              { "id": 4, "text": "D category: Commercial Areas", "value": [0.7, 0.7, 0.6] },
              { "id": 5, "text": "E category: Storage Zones", "value": [1.0, 0.9, 0.8] },
              { "id": 6, "text": "F category: Light Vehicle Circulation Areas (<=30 kN)", "value": [0.7, 0.7, 0.6] },
              { "id": 7, "text": "G category: Medium Vehicle Circulation Zones (>30 kN and <=160 kN)", "value": [0.7, 0.5, 0.3] }
            ],
            "3": [
              { "id": 0, "text": "Definido por el usuario", "value": [0, 0, 0] },
              { "id": 1, "text": "Categoría A: Áreas residenciales", "value": [0.7, 0.5, 0.3] },
              { "id": 2, "text": "Categoría B: Zonas de oficina", "value": [0.7, 0.5, 0.3] },
              { "id": 3, "text": "Categoría C: Zonas de reunión", "value": [0.7, 0.7, 0.6] },
              { "id": 4, "text": "Categoría D: Áreas comerciales", "value": [0.7, 0.7, 0.6] },
              { "id": 5, "text": "Categoría E: Zonas de almacenamiento", "value": [1.0, 0.9, 0.8] },
              { "id": 6, "text": "Categoría F: Áreas de circulación de vehículos ligeros (<= 30 kN)", "value": [0.7, 0.7, 0.6] },
              { "id": 7, "text": "Categoría G: Zonas de circulación de vehículos medianos (> 30 kN y <= 160 kN)", "value": [0.7, 0.5, 0.3] }
            ],
            "4": [
              { "id": 0, "text": "Défini par l'utilisateur", "value": [0, 0, 0] },
              { "id": 1, "text": "Catégorie A: Zones résidentielles", "value": [0.7, 0.5, 0.3] },
              { "id": 2, "text": "Catégorie B: Zones de bureaux", "value": [0.7, 0.5, 0.3] },
              { "id": 3, "text": "Catégorie C: Zones de réunion", "value": [0.7, 0.7, 0.6] },
              { "id": 4, "text": "Catégorie D: zones commerciales", "value": [0.7, 0.7, 0.6] },
              { "id": 5, "text": "Catégorie E: Zones de stockage", "value": [1.0, 0.9, 0.8] },
              { "id": 6, "text": "Catégorie F: zones de circulation des véhicules légers (<= 30 kN)", "value": [0.7, 0.7, 0.6] },
              { "id": 7, "text": "Catégorie G: zones de circulation des véhicules moyens (> 30 kN et <= 160 kN)", "value": [0.7, 0.5, 0.3] }
            ],
            "5": [
              { "id": 0, "text": "Benutzerdefiniert", "value": [0, 0, 0] },
              { "id": 1, "text": "A category: Residential Areas", "value": [0.7, 0.5, 0.3] },
              { "id": 2, "text": "B category: Office Zones", "value": [0.7, 0.5, 0.3] },
              { "id": 3, "text": "C category: Meeting Zones", "value": [0.7, 0.7, 0.6] },
              { "id": 4, "text": "D category: Commercial Areas", "value": [0.7, 0.7, 0.6] },
              { "id": 5, "text": "E category: Storage Zones", "value": [1.0, 0.9, 0.8] },
              { "id": 6, "text": "F category: Light Vehicle Circulation Areas (<=30 kN)", "value": [0.7, 0.7, 0.6] },
              { "id": 7, "text": "G category: Medium Vehicle Circulation Zones (>30 kN and <=160 kN)", "value": [0.7, 0.5, 0.3] }
            ]
          }
        },

        "type-4": {

          "list": {
            "-1": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "H category: roof", "value": [0, 0, 0] }
            ],
            "1": [
              { "id": 0, "text": "Definido pelo utilizador", "value": [0, 0, 0] },
              { "id": 1, "text": "Categoria H: coberturas", "value": [0, 0, 0] }
            ],
            "2": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "H category: roof", "value": [0, 0, 0] }
            ],
            "3": [
              { "id": 0, "text": "Definido por el usuario", "value": [0, 0, 0] },
              { "id": 1, "text": "Categoría H: coberturas", "value": [0, 0, 0] }
            ],
            "4": [
              { "id": 0, "text": "Défini par l'utilisateur", "value": [0, 0, 0] },
              { "id": 1, "text": "Catégorie H: couverture", "value": [0, 0, 0] }
            ],
            "5": [
              { "id": 0, "text": "User defined", "value": [0, 0, 0] },
              { "id": 1, "text": "H category: roof", "value": [0, 0, 0] }
            ]
          }
        }
      },

      "wind": {

        "list": {
          "-1": [
            { "id": 0, "text": "User defined", "value": [0, 0, 0] },
            { "id": 1, "text": "EN 1991-1-4", "value": [0.6, 0.2, 0.0] }
          ],
          "1": [
            { "id": 0, "text": "Definido pelo utilizador", "value": [0, 0, 0] },
            { "id": 1, "text": "EN 1991-1-4", "value": [0.6, 0.2, 0.0] }
          ],
          "2": [
            { "id": 0, "text": "User defined", "value": [0, 0, 0] },
            { "id": 1, "text": "EN 1991-1-4", "value": [0.6, 0.2, 0.0] }
          ],
          "3": [
            { "id": 0, "text": "Definido por el usuario", "value": [0, 0, 0] },
            { "id": 1, "text": "EN 1991-1-4", "value": [0.6, 0.2, 0.0] }
          ],
          "4": [
            { "id": 0, "text": "Défini par l'utilisateur", "value": [0, 0, 0] },
            { "id": 1, "text": "EN 1991-1-4", "value": [0.6, 0.2, 0.0] }
          ],
          "5": [
            { "id": 0, "text": "Benutzerdefiniert", "value": [0, 0, 0] },
            { "id": 1, "text": "EN 1991-1-4", "value": [0.6, 0.2, 0.0] }
          ]
        }
      },

      "snow": {

        "list": {
          "-1": [
            { "id": 0, "text": "User defined", "value": [0, 0, 0] },
            { "id": 1, "text": "H<=1000 m", "value": [0.5, 0.2, 0] },
            { "id": 2, "text": "H>1000 m", "value": [0.7, 0.5, 0.2] }
          ],
          "1": [
            { "id": 0, "text": "Definido pelo utilizador", "value": [0, 0, 0] },
            { "id": 1, "text": "H<=1000 m", "value": [0.5, 0.2, 0] },
            { "id": 2, "text": "H>1000 m", "value": [0.7, 0.5, 0.2] }
          ],
          "2": [
            { "id": 0, "text": "User defined", "value": [0, 0, 0] },
            { "id": 1, "text": "H<=1000 m", "value": [0.5, 0.2, 0] },
            { "id": 2, "text": "H>1000 m", "value": [0.7, 0.5, 0.2] }
          ],
          "3": [
            { "id": 0, "text": "Definido por el usuario", "value": [0, 0, 0] },
            { "id": 1, "text": "H<=1000 m", "value": [0.5, 0.2, 0] },
            { "id": 2, "text": "H>1000 m", "value": [0.7, 0.5, 0.2] }
          ],
          "4": [
            { "id": 0, "text": "Défini par l'utilisateur", "value": [0, 0, 0] },
            { "id": 1, "text": "H<=1000 m", "value": [0.5, 0.2, 0] },
            { "id": 2, "text": "H>1000 m", "value": [0.7, 0.5, 0.2] }
          ],
          "5": [
            { "id": 0, "text": "Benutzerdefiniert", "value": [0, 0, 0] },
            { "id": 1, "text": "H<=1000 m", "value": [0.5, 0.2, 0] },
            { "id": 2, "text": "H>1000 m", "value": [0.7, 0.5, 0.2] }
          ]
        }
      }
    },

    "spanRestraintsDefaults": {
      "1": {
        "upperFibre": -1,
        "lowerFibre": 0
      },

      "2": {
        "upperFibre": 0,
        "lowerFibre": 0
      },

      "3": {
        "upperFibre": -1,
        "lowerFibre": 2
      },

      "4": {
        "upperFibre": -1,
        "lowerFibre": 0
      }
    }
  }

}
